import type { Alpine } from 'alpinejs'
import collapse from '@alpinejs/collapse'

export default (Alpine: Alpine) => {
  Alpine.plugin(collapse)
}
